module.exports = __webpack_public_path__ + "img/management-team-icon-in-circle.a4dc1f76.svg";